import type { Action, ActionName, NamespacedAction } from './Action';

export const actionCreatorSymbol = Symbol('RXBEACH_ACTION_CREATOR');
export type ActionCreatorSymbol = typeof actionCreatorSymbol;

/**
 * Type of the action creator functions
 *
 * @template `Payload` - The payload type to dispatch on
 */
export interface ActionCreatorWithoutNamespace<Payload = void> {
  (payload: Payload): Action<Payload>;
  type: ActionName;
  actionCreatorSymbol: ActionCreatorSymbol;
}

/**
 * Action creator function which requires a namespace
 *
 * @template `Payload` - The payload type to dispatch on
 */
export interface NamespacedActionCreator<Payload = void> {
  (namespace: string, payload: Payload): NamespacedAction<Payload>;
  type: ActionName;
  actionCreatorSymbol: ActionCreatorSymbol;
}

export type ActionCreator<Payload = void> =
  | ActionCreatorWithoutNamespace<Payload>
  | NamespacedActionCreator<Payload>;

/**
 * @deprecated use ActionCreator instead
 */
export type ActionCreatorWithoutPayload = ActionCreatorWithoutNamespace<void>;

/**
 * @deprecated use ActionCreator instead
 */
export type ActionCreatorWithPayload<Payload = void> =
  ActionCreatorWithoutNamespace<Payload>;
